import {
  GET_CHILD_SUPPLIERS_START,
  GET_CHILD_SUPPLIERS_SUCCESS,
  GET_CHILD_SUPPLIERS_FAILED,
  GET_CHILD_SUPPLIERS_WITH_MASTER_IDS_START,
  GET_CHILD_SUPPLIERS_WITH_MASTER_IDS_SUCCESS,
  GET_CHILD_SUPPLIERS_WITH_MASTER_IDS_FAIL,
  GET_CHILD_SUPPLIERS_WITH_MASTER_ID_START,
  GET_CHILD_SUPPLIERS_WITH_MASTER_ID_SUCCESS,
  GET_CHILD_SUPPLIERS_WITH_MASTER_ID_FAIL,
  GET_MASTER_SUPPLIERS_START,
  GET_MASTER_SUPPLIERS_SUCCESS,
  GET_MASTER_SUPPLIERS_FAILED,
  GET_MASTER_SUPPLIER_DETAILS_BY_ID_START,
  GET_MASTER_SUPPLIER_DETAILS_BY_ID_SUCCESS,
  GET_MASTER_SUPPLIER_DETAILS_BY_ID_FAIL,
  REMOVE_MASTER_START,
  REMOVE_MASTER_SUCCESS,
  REMOVE_MASTER_FAILED,
  ASSIGN_MASTER_START,
  ASSIGN_MASTER_SUCCESS,
  ASSIGN_MASTER_FAILED,
  CREATE_MASTER_FROM_CHILDS_START,
  CREATE_MASTER_FROM_CHILDS_SUCCESS,
  CREATE_MASTER_FROM_CHILDS_FAIL,
  UPDATE_SUPPLIER_BASIC_INFO_START,
  UPDATE_SUPPLIER_BASIC_INFO_SUCCESS,
  UPDATE_SUPPLIER_BASIC_INFO_FAIL,
  UPDATE_SUPPLIER_CARD_INFO_START,
  UPDATE_SUPPLIER_CARD_INFO_SUCCESS,
  UPDATE_SUPPLIER_CARD_INFO_FAIL,
  UPDATE_SUPPLIER_PAYMENT_INFO_START,
  UPDATE_SUPPLIER_PAYMENT_INFO_SUCCESS,
  UPDATE_SUPPLIER_PAYMENT_INFO_FAIL,
  UPDATE_SUPPLIER_DETAIL_INFO_START,
  UPDATE_SUPPLIER_DETAIL_INFO_SUCCESS,
  UPDATE_SUPPLIER_DETAIL_INFO_FAIL,
  GET_CHILD_SUPPLIERS_FOR_QA_START,
  GET_CHILD_SUPPLIERS_FOR_QA_SUCCSS,
  GET_CHILD_SUPPLIERS_FOR_QA_FAIL,
  GET_MASTER_SUPPLIERS_FOR_QA_START,
  GET_MASTER_SUPPLIERS_FOR_QA_SUCCSS,
  GET_MASTER_SUPPLIERS_FOR_QA_FAIL,
  APPROVE_SUPPLIERS_START,
  APPROVE_SUPPLIERS_SUCCESS,
  APPROVE_SUPPLIERS_FAIL,
  REJECT_SUPPLIERS_START,
  REJECT_SUPPLIERS_SUCCESS,
  REJECT_SUPPLIERS_FAIL,
  ADD_SUPPLIER_CARD_EMAIL_INFO_START,
  ADD_SUPPLIER_CARD_EMAIL_INFO_SUCCESS,
  ADD_SUPPLIER_CARD_EMAIL_INFO_FAIL,
  REMOVE_SUPPLIER_CARD_EMAIL_INFO_START,
  REMOVE_SUPPLIER_CARD_EMAIL_INFO_SUCCESS,
  REMOVE_SUPPLIER_CARD_EMAIL_INFO_FAIL,
  UPDATE_SUPPLIER_CARD_EMAIL_INFO_START,
  UPDATE_SUPPLIER_CARD_EMAIL_INFO_SUCCESS,
  UPDATE_SUPPLIER_CARD_EMAIL_INFO_FAIL,
  GET_RELATED_SUPPLIER_WITH_ID_START,
  GET_RELATED_SUPPLIER_WITH_ID_SUCCESS,
  GET_RELATED_SUPPLIER_WITH_ID_FAIL,
  ADD_SUPPLIER_HISTORY_START,
  ADD_SUPPLIER_HISTORY_SUCCESS,
  ADD_SUPPLIER_HISTORY_FAIL,
  GET_ALL_SUPPLIERS_DATA_START,
  GET_ALL_SUPPLIERS_DATA_SUCCESS,
  GET_ALL_SUPPLIERS_DATA_FAIL,
  REMOVE_MASTER_SUPPLIER_DETAILS,
  GET_LOCATION_BASED_MASTER_SUPPLIERS_START,
  GET_LOCATION_BASED_MASTER_SUPPLIERS_SUCCESS,
  GET_LOCATION_BASED_MASTER_SUPPLIERS_FAILED,
  GET_ALL_MASTER_SUPPLIERS_DATA_START,
  GET_ALL_MASTER_SUPPLIERS_DATA_SUCCESS,
  GET_ALL_MASTER_SUPPLIERS_DATA_FAIL,
  GET_LOCATION_BASED_MASTER_SUPPLIERS_FOR_QA_START,
  GET_LOCATION_BASED_MASTER_SUPPLIERS_FOR_QA_SUCCESS,
  GET_LOCATION_BASED_MASTER_SUPPLIERS_FOR_QA_FAIL,
  CREATE_CHILD_START,
  CREATE_CHILD_SUCCESS,
  CREATE_CHILD_FAIL,
  UPDATE_GLOBAL_ACCEPTANCE,
  UPDATE_SUPPLIERS_SEARCH_LIST,
  UPDATE_SUPPLIERS_SEARCH_RESULTS,
  GET_CONTACTS_WITH_SUPPLIER_IDS_START,
  GET_CONTACTS_WITH_SUPPLIER_IDS_SUCCESS,
  GET_CONTACTS_WITH_SUPPLIER_IDS_FAIL
} from '../actionTypes/vendor'

// The initial state of the App
export const initialState = {
  suppliers: [],
  masterSuppliers: [],
  masterSuppliersContacts: [],
  childSuppliersContacts: [],
  suppliersForQA: [],
  masterSuppliersForQA: [],
  locationBasedMasterSuppliersForQA: [],
  isLoadingChildSupplier: false,
  isLoadingMasterSupplier: false,
  isLoadingMasterDetail: false,
  masterSupplierDetails: {
    baseInfo: {},
    cardInfo: {},
    checkInfo: {},
    achInfo: {},
    detailInfo: {},
    childVendors: [],
    cardEmailsInfo: {},
    supplierHistory: {},
    paymentInfo: {},
    cardFeeInfo: {},
    callRecordings: [],
    contactsData: [],
    contacts: []
  },
  relatedSupplierDetails: {
    relatedSupplierInfo: {}
  },
  isCreatingMaster: false,
  isUpdatingSupplier: false,
  isAssigningMaster: false,
  isRemovingFromMaster: false,
  supplierHistory: [],
  allSuppliers: [],
  isLoadingLocationMasterSupplier: false,
  locationMasterSuppliers: [],
  allMasterSuppliers: [],
  isCreatingChild: false,
  suppliersSearchList: {},
  suppliersSearchResults: {
    masters: {},
    childs: {},
    locationMasters: {}
  },
  isLoadingRelatedSupplier: false,
  isLoadingSupplierContacts: false
}

const vendor = (state = initialState, action) => {
  switch (action.type) {
    case GET_CHILD_SUPPLIERS_START:
      return {
        ...state,
        isLoadingChildSupplier: true
      }
    case GET_CHILD_SUPPLIERS_FAILED:
      return {
        ...state,
        isLoadingChildSupplier: false
      }
    case GET_CHILD_SUPPLIERS_SUCCESS:
      if (action.searchListLength === 0 && !action.noMaster && !action.hasMaster) {
        return {
          ...state,
          suppliers: action.data,
          childSuppliersContacts: action?.contacts || [],
          isLoadingChildSupplier: false
        }
      } else {
        return {
          ...state,
          isLoadingChildSupplier: false
        }
      }
    case GET_CHILD_SUPPLIERS_WITH_MASTER_IDS_START:
      return {
        ...state,
        isLoadingChildSupplier: true
      }
    case GET_CHILD_SUPPLIERS_WITH_MASTER_IDS_SUCCESS:
      return {
        ...state,
        isLoadingChildSupplier: false,
        // suppliers: action.data
      }
    case GET_CHILD_SUPPLIERS_WITH_MASTER_IDS_FAIL:
      return {
        ...state,
        isLoadingChildSupplier: false,
        // suppliers: []
      }
    case GET_CHILD_SUPPLIERS_WITH_MASTER_ID_START:
      return {
        ...state,
        isLoadingChildSupplier: true
      }
    case GET_CHILD_SUPPLIERS_WITH_MASTER_ID_SUCCESS:
      return {
        ...state,
        isLoadingChildSupplier: false,
        masterSupplierDetails: {
          ...state.masterSupplierDetails,
          childVendors: action.data
        }
      }
    case GET_CHILD_SUPPLIERS_WITH_MASTER_ID_FAIL:
      return {
        ...state,
        isLoadingChildSupplier: false,
        masterSupplierDetails: {
          ...state.masterSupplierDetails,
          childVendors: []
        }
      }
    case GET_MASTER_SUPPLIERS_START:
      return {
        ...state,
        isLoadingMasterSupplier: true
      }
    case GET_MASTER_SUPPLIERS_FAILED:
      return {
        ...state,
        isLoadingMasterSupplier: false
      }
    case GET_MASTER_SUPPLIERS_SUCCESS:
      if (action.searchListLength === 0) {
        return {
          ...state,
          masterSuppliers: action.data,
          masterSuppliersContacts: action?.contacts || [],
          isLoadingMasterSupplier: false
        }
      } else {
        return {
          ...state,
          isLoadingMasterSupplier: false
        }
      }
    case GET_MASTER_SUPPLIER_DETAILS_BY_ID_START:
      return {
        ...state,
        isLoadingMasterDetail: true,
      }
    case GET_MASTER_SUPPLIER_DETAILS_BY_ID_SUCCESS:
      return {
        ...state,
        masterSupplierDetails: {
          ...state.masterSupplierDetails,
          baseInfo: action.data.supplierInfo ? action.data.supplierInfo : {},
          cardInfo: action.data.cardInfo ? action.data.cardInfo : {},
          checkInfo: action.data.paymentInfo ? action.data.paymentInfo : {},
          paymentInfo: action.data.paymentInfo ? action.data.paymentInfo : {},
          detailInfo: action.data.detailInfo ? action.data.detailInfo : {},
          cardEmailsInfo: action.data.cardEmailsInfo ? action.data.cardEmailsInfo : [],
          supplierHistory: action.data.supplierHistory ? action.data.supplierHistory : [],
          cardFeeInfo: action.data.cardFeeInfo ? action.data.cardFeeInfo : [],
          callRecordings: action.data.callRecordings ? action.data.callRecordings : [],
          contactsData: action.data.contactsData ? action.data.contactsData : [],
        },
        isLoadingMasterDetail: false,
      }
    case GET_MASTER_SUPPLIER_DETAILS_BY_ID_FAIL:
      return {
        ...state,
        isLoadingMasterDetail: false,
      }
    case REMOVE_MASTER_START:
      return {
        ...state,
        isRemovingFromMaster: true
      }
    case REMOVE_MASTER_SUCCESS:
      return {
        ...state,
        isRemovingFromMaster: false,
        suppliers: [
          ...state.suppliers.map(supplier => {
            const tmpSupplier = JSON?.parse(JSON?.stringify(supplier))
            if (action.data && action.data.length > 0) {
              const updatedIndex = action.data.findIndex(row => row.id === tmpSupplier.id)
              if (updatedIndex > -1) {
                tmpSupplier.masterId = null
                tmpSupplier.masterSupplierName = ''
                tmpSupplier.masterSupplierInfo = null
                tmpSupplier.supplierQARole = 'Pending'
              }
            }
            return tmpSupplier
          })
        ]
      }
    case REMOVE_MASTER_FAILED:
      return {
        ...state,
        isRemovingFromMaster: false
      }
    case ASSIGN_MASTER_START:
      return {
        ...state,
        isAssigningMaster: true,
      }
    case ASSIGN_MASTER_SUCCESS:
      return {
        ...state,
        isAssigningMaster: false,
        suppliers: [
          ...state.suppliers.map(supplier => {
            const tmpSupplier = JSON?.parse(JSON?.stringify(supplier))
            if (action.data && action.data.updatedSupplier.length > 0) {
              const updatedIndex = action.data.updatedSupplier.findIndex(row => row.id === tmpSupplier.id)
              if (updatedIndex > -1) {
                tmpSupplier.masterId = action.data.updatedSupplier[updatedIndex].masterId
                tmpSupplier.masterSupplierName = action.data.masterInfo.suppliername
                tmpSupplier.masterSupplierInfo = action.data.masterInfo
                tmpSupplier.supplierQARole = 'Pending'
              }
            }
            return tmpSupplier
          })
        ]
      }
    case ASSIGN_MASTER_FAILED:
      return {
        ...state,
        isAssigningMaster: false,
      }
    case CREATE_MASTER_FROM_CHILDS_START:
      return {
        ...state,
        isCreatingMaster: true
      }
    case CREATE_MASTER_FROM_CHILDS_SUCCESS:
      return {
        ...state,
        isCreatingMaster: false,
        masterSuppliers: [...state.masterSuppliers, action.data]
      }
    case CREATE_MASTER_FROM_CHILDS_FAIL:
      return {
        ...state,
        isCreatingMaster: false
      }
    case UPDATE_SUPPLIER_BASIC_INFO_START:
      return {
        ...state,
        isUpdatingSupplier: true,
      }
    case UPDATE_SUPPLIER_BASIC_INFO_SUCCESS:
      if (action.supType === 'master') {
        if (action?.isUpdateInRedux) {
          return {
            ...state,
            isUpdatingSupplier: false,
            masterSupplierDetails: {
              ...state.masterSupplierDetails,
              baseInfo: action?.data?.updatedSupplier,
              detailInfo: action?.data?.supplierDetails ? action?.data?.supplierDetails : state?.masterSupplierDetails?.detailInfo
              // cardInfo: action.data.cardInfo?.[0],
            }
          }
        } else {
          return {
            ...state,
            isUpdatingSupplier: false
          }
        }
      } else if (action.supType === 'relatedEIN') { // case when child supplier EIN will change
        return {
          ...state,
          isUpdatingSupplier: false,
          relatedSupplierDetails: {
            ...state.relatedSupplierDetails,
            relatedSupplierInfo: {
              ...state.relatedSupplierDetails.relatedSupplierInfo,
              baseInfo: action?.data?.updatedSupplier ? action?.data?.updatedSupplier : {},
              detailInfo: action?.data?.supplierDetails ? action?.data?.supplierDetails : state?.relatedSupplierDetails?.relatedSupplierInfo?.detailInfo
            }
          }
        }
      } else {
        return {
          ...state,
          isUpdatingSupplier: false,
          relatedSupplierDetails: {
            ...state.relatedSupplierDetails,
            relatedSupplierInfo: {
              ...state.relatedSupplierDetails.relatedSupplierInfo,
              masterSupplierInfo: {
                ...state.relatedSupplierDetails.relatedSupplierInfo.masterSupplierInfo,
                baseInfo: action.data.updatedSupplier ? action.data.updatedSupplier : {},
                detailInfo: action?.data?.supplierDetails ? action?.data?.supplierDetails : state?.relatedSupplierDetails?.relatedSupplierInfo?.masterSupplierInfo?.detailInfo
              }
            }
          }
        }
      }
    case UPDATE_SUPPLIER_BASIC_INFO_FAIL:
      return {
        ...state,
        isUpdatingSupplier: false,
      }
    case UPDATE_SUPPLIER_CARD_INFO_START:
      return {
        ...state,
        isUpdatingSupplier: true,
      }
    case UPDATE_SUPPLIER_CARD_INFO_SUCCESS:
      if (action.supType === 'master') {
        if (action?.isUpdateInRedux) {
          return {
            ...state,
            isUpdatingSupplier: false,
            masterSupplierDetails: {
              ...state.masterSupplierDetails,
              cardInfo: action.data.updatedCard,
              cardFeeInfo: action.data.cardFeeData,
              detailInfo: action?.supDetailInfo ? action?.supDetailInfo : state.masterSupplierDetails?.detailInfo
            }
          }
        } else {
          return {
            ...state,
            isUpdatingSupplier: false,
          }
        }
      } else {
        return {
          ...state,
          isUpdatingSupplier: false,
          relatedSupplierDetails: {
            ...state.relatedSupplierDetails,
            relatedSupplierInfo: {
              ...state.relatedSupplierDetails.relatedSupplierInfo,
              masterSupplierInfo: {
                ...state.relatedSupplierDetails.relatedSupplierInfo.masterSupplierInfo,
                cardInfo: action?.data?.updatedCard ? action?.data?.updatedCard : {},
                cardFeeInfo: action?.data?.cardFeeData ? action?.data?.cardFeeData : {},
                detailInfo: action?.supDetailInfo ? action?.supDetailInfo : state?.relatedSupplierDetails?.relatedSupplierInfo?.masterSupplierInfo?.detailInfo
              }
            }
          }
        }
      }
    case UPDATE_SUPPLIER_CARD_INFO_FAIL:
      return {
        ...state,
        isUpdatingSupplier: false,
      }
    case UPDATE_SUPPLIER_PAYMENT_INFO_START:
      return {
        ...state,
        isUpdatingSupplier: true,
      }
    case UPDATE_SUPPLIER_PAYMENT_INFO_SUCCESS:
      if (action.supType === 'master') {
        if (action?.isUpdateInRedux) {
          return {
            ...state,
            isUpdatingSupplier: false,
            masterSupplierDetails: {
              ...state.masterSupplierDetails,
              paymentInfo: action.data,
              checkInfo: action.data,
              detailInfo: action?.supDetailInfo ? action.supDetailInfo : state.masterSupplierDetails?.detailInfo
            }
          }
        } else {
          return {
            ...state,
            isUpdatingSupplier: false
          }
        }
      } else {
        return {
          ...state,
          isUpdatingSupplier: false,
          relatedSupplierDetails: {
            ...state.relatedSupplierDetails,
            relatedSupplierInfo: {
              ...state.relatedSupplierDetails.relatedSupplierInfo,
              masterSupplierInfo: {
                ...state.relatedSupplierDetails.relatedSupplierInfo.masterSupplierInfo,
                paymentInfo: action?.data ? action?.data : {}
              }
            }
          }
        }
      }

    case UPDATE_SUPPLIER_PAYMENT_INFO_FAIL:
      return {
        ...state,
        isUpdatingSupplier: false,
      }
    case UPDATE_SUPPLIER_DETAIL_INFO_START:
      return {
        ...state,
        isUpdatingSupplier: true,
      }
    case UPDATE_SUPPLIER_DETAIL_INFO_SUCCESS:
      return state?.masterSupplierDetails?.detailInfo?.supplierId === action.data.supplierId ?
        {
          ...state,
          isUpdatingSupplier: false,
          masterSupplierDetails: {
            ...state.masterSupplierDetails,
            detailInfo: action.data,
          }
        } :
        {
          ...state,
          isUpdatingSupplier: false,
          relatedSupplierDetails: {
            ...state.relatedSupplierDetails,
            relatedSupplierInfo: {
              ...state.relatedSupplierDetails.relatedSupplierInfo,
              detailInfo: action.data
            }
          }
        }

    case UPDATE_SUPPLIER_DETAIL_INFO_FAIL:
      return {
        ...state,
        isUpdatingSupplier: false,
      }
    case GET_CHILD_SUPPLIERS_FOR_QA_START:
      return {
        ...state,
        isLoadingChildSupplier: true,
      }
    case GET_CHILD_SUPPLIERS_FOR_QA_SUCCSS:
      return {
        ...state,
        isLoadingChildSupplier: false,
        suppliersForQA: action.data,
      }
    case GET_CHILD_SUPPLIERS_FOR_QA_FAIL:
      return {
        ...state,
        isLoadingChildSupplier: false,
      }
    case GET_MASTER_SUPPLIERS_FOR_QA_START:
      return {
        ...state,
        isLoadingMasterSupplier: true,
      }
    case GET_MASTER_SUPPLIERS_FOR_QA_SUCCSS:
      return {
        ...state,
        isLoadingMasterSupplier: false,
        masterSuppliersForQA: action.data
      }
    case GET_MASTER_SUPPLIERS_FOR_QA_FAIL:
      return {
        ...state,
        isLoadingMasterSupplier: false,
      }
    case APPROVE_SUPPLIERS_START:
      return {
        ...state,
        isUpdatingSupplier: true,
      }
    case APPROVE_SUPPLIERS_SUCCESS:
      if (action.data.type === 'child') {
        let tmpChildSuppliersForQA = [...state.suppliersForQA]
        tmpChildSuppliersForQA = tmpChildSuppliersForQA.map(supplier => {
          if (action.data.updatedSupplierDetails || action.data.updatedSupplierDetails.length > 0) {
            if (action.data.updatedSupplierDetails.findIndex(updatedSupplierDetail => updatedSupplierDetail.supplierId === supplier.id) !== -1) {
              return {
                ...supplier,
                supplierQARole: 'Approved'
              }
            }
            return supplier
          }
          return supplier
        })
        return {
          ...state,
          suppliersForQA: tmpChildSuppliersForQA,
          isUpdatingSupplier: false,
        }
      } else if (action.data.type === 'master') {
        let tmpMasterSuppliersForQA = [...state.masterSuppliersForQA]
        tmpMasterSuppliersForQA = tmpMasterSuppliersForQA.map(supplier => {
          if (action.data.updatedSupplierDetails || action.data.updatedSupplierDetails.length > 0) {
            if (action.data.updatedSupplierDetails.findIndex(updatedSupplierDetail => updatedSupplierDetail.supplierId === supplier.id) !== -1) {
              return {
                ...supplier,
                supplierQARole: 'Approved'
              }
            }
            return supplier
          }
          return supplier
        })
        return {
          ...state,
          masterSuppliersForQA: tmpMasterSuppliersForQA,
          isUpdatingSupplier: false,
        }
      } else if (action.data.type === 'locationMaster') {
        let tmpLocationBasedMasterSuppliersForQA = [...state.locationBasedMasterSuppliersForQA]
        tmpLocationBasedMasterSuppliersForQA = tmpLocationBasedMasterSuppliersForQA.map(supplier => {
          if (action.data.updatedSupplierDetails || action.data.updatedSupplierDetails.length > 0) {
            if (action.data.updatedSupplierDetails.findIndex(updatedSupplierDetail => updatedSupplierDetail.supplierId === supplier.id) !== -1) {
              return {
                ...supplier,
                supplierQARole: 'Approved'
              }
            }
            return supplier
          }
          return supplier
        })
        return {
          ...state,
          locationBasedMasterSuppliersForQA: tmpLocationBasedMasterSuppliersForQA,
          isUpdatingSupplier: false,
        }
      } else if (action.data.type === 'singleMaster') {
        return {
          ...state,
          masterSupplierDetails: {
            ...state.masterSupplierDetails,
            detailInfo: action.data?.updatedSupplierDetails?.[0]
          }
        }
      } else if (action.data.type === 'singleChild') {
        return {
          ...state,
          relatedSupplierDetails: {
            ...state.relatedSupplierDetails,
            relatedSupplierInfo: {
              ...state.relatedSupplierDetails.relatedSupplierInfo,
              detailInfo: action.data?.updatedSupplierDetails?.[0]
            }
          }
        }
      }
      return state
    case APPROVE_SUPPLIERS_FAIL:
      return {
        ...state,
        isUpdatingSupplier: false,
      }
    case REJECT_SUPPLIERS_START:
      return {
        ...state,
        isUpdatingSupplier: true,
      }
    case REJECT_SUPPLIERS_SUCCESS:
      if (action.data.type === 'child') {
        let tmpChildSuppliersForQA = [...state.suppliersForQA]
        tmpChildSuppliersForQA = tmpChildSuppliersForQA.map(supplier => {
          if (action.data.updatedSupplierDetails || action.data.updatedSupplierDetails.length > 0) {
            if (action.data.updatedSupplierDetails.findIndex(updatedSupplierDetail => updatedSupplierDetail.supplierId === supplier.id) !== -1) {
              return {
                ...supplier,
                supplierQARole: 'Rejected'
              }
            }
            return supplier
          }
          return supplier
        })
        return {
          ...state,
          suppliersForQA: tmpChildSuppliersForQA,
          isUpdatingSupplier: false,
        }
      } else if (action.data.type === 'master') {
        let tmpMasterSuppliersForQA = [...state.masterSuppliersForQA]
        tmpMasterSuppliersForQA = tmpMasterSuppliersForQA.map(supplier => {
          if (action.data.updatedSupplierDetails || action.data.updatedSupplierDetails.length > 0) {
            if (action.data.updatedSupplierDetails.findIndex(updatedSupplierDetail => updatedSupplierDetail.supplierId === supplier.id) !== -1) {
              return {
                ...supplier,
                supplierQARole: 'Rejected'
              }
            }
            return supplier
          }
          return supplier
        })
        return {
          ...state,
          masterSuppliersForQA: tmpMasterSuppliersForQA,
          isUpdatingSupplier: false,
        }
      } else if (action.data.type === 'locationMaster') {
        let tmpLocationBasedMasterSuppliersForQA = [...state.locationBasedMasterSuppliersForQA]
        tmpLocationBasedMasterSuppliersForQA = tmpLocationBasedMasterSuppliersForQA.map(supplier => {
          if (action.data.updatedSupplierDetails || action.data.updatedSupplierDetails.length > 0) {
            if (action.data.updatedSupplierDetails.findIndex(updatedSupplierDetail => updatedSupplierDetail.supplierId === supplier.id) !== -1) {
              return {
                ...supplier,
                supplierQARole: 'Rejected'
              }
            }
            return supplier
          }
          return supplier
        })
        return {
          ...state,
          locationBasedMasterSuppliersForQA: tmpLocationBasedMasterSuppliersForQA,
          isUpdatingSupplier: false,
        }
      } else if (action.data.type === 'singleMaster') {
        return {
          ...state,
          masterSupplierDetails: {
            ...state.masterSupplierDetails,
            detailInfo: action.data?.updatedSupplierDetails?.[0]
          }
        }
      } else if (action.data.type === 'singleChild') {
        return {
          ...state,
          relatedSupplierDetails: {
            ...state.relatedSupplierDetails,
            relatedSupplierInfo: {
              ...state.relatedSupplierDetails.relatedSupplierInfo,
              detailInfo: action.data?.updatedSupplierDetails?.[0]
            }
          }
        }
      }
      return state
    case REJECT_SUPPLIERS_FAIL:
      return {
        ...state,
        isUpdatingSupplier: false,
      }
    case ADD_SUPPLIER_CARD_EMAIL_INFO_START:
      return {
        ...state,
        isUpdatingSupplier: true,
      }
    case ADD_SUPPLIER_CARD_EMAIL_INFO_SUCCESS:
      if (action.supType === 'master') {
        return {
          ...state,
          isUpdatingSupplier: false,
          masterSupplierDetails: {
            ...state.masterSupplierDetails,
            cardEmailsInfo: action.data.data,
          }
        }
      } else {
        return {
          ...state,
          isUpdatingSupplier: false,
          relatedSupplierDetails: {
            ...state.relatedSupplierDetails,
            relatedSupplierInfo: {
              ...state.relatedSupplierDetails.relatedSupplierInfo,
              masterSupplierInfo: {
                ...state.relatedSupplierDetails.relatedSupplierInfo.masterSupplierInfo,
                cardEmailsInfo: action?.data?.data ? action?.data?.data : {}
              }
            }
          }
        }
      }
    case ADD_SUPPLIER_CARD_EMAIL_INFO_FAIL:
      return {
        ...state,
        isUpdatingSupplier: false,
      }
    case REMOVE_SUPPLIER_CARD_EMAIL_INFO_START:
      return {
        ...state,
        isUpdatingSupplier: true,
      }
    case REMOVE_SUPPLIER_CARD_EMAIL_INFO_SUCCESS:
      if (action.supType === 'master') {
        return {
          ...state,
          isUpdatingSupplier: false,
          masterSupplierDetails: {
            ...state.masterSupplierDetails,
            cardEmailsInfo: action.data.data,
          }
        }
      } else {
        return {
          ...state,
          isUpdatingSupplier: false,
          relatedSupplierDetails: {
            ...state.relatedSupplierDetails,
            relatedSupplierInfo: {
              ...state.relatedSupplierDetails.relatedSupplierInfo,
              masterSupplierInfo: {
                ...state.relatedSupplierDetails.relatedSupplierInfo.masterSupplierInfo,
                cardEmailsInfo: action?.data?.data ? action?.data?.data : {}
              }
            }
          }
        }
      }
    case REMOVE_SUPPLIER_CARD_EMAIL_INFO_FAIL:
      return {
        ...state,
        isUpdatingSupplier: false,
      }
    case UPDATE_SUPPLIER_CARD_EMAIL_INFO_START:
      return {
        ...state,
        isUpdatingSupplier: true,
      }
    case UPDATE_SUPPLIER_CARD_EMAIL_INFO_SUCCESS:
      return {
        ...state,
        isUpdatingSupplier: false,
        masterSupplierDetails: {
          ...state.masterSupplierDetails,
          cardEmailsInfo: action.data.data,
        }
      }
    case UPDATE_SUPPLIER_CARD_EMAIL_INFO_FAIL:
      return {
        ...state,
        isUpdatingSupplier: false,
      }
    case GET_RELATED_SUPPLIER_WITH_ID_START:
      return {
        ...state,
        isLoadingRelatedSupplier: true
        // isLoadingChildSupplier: true,
        // isLoadingMasterDetail: true
      }
    case GET_RELATED_SUPPLIER_WITH_ID_SUCCESS:
      return {
        ...state,
        isLoadingRelatedSupplier: false,
        // isLoadingChildSupplier: false,
        // isLoadingMasterDetail: false,
        relatedSupplierDetails: {
          ...state.relatedSupplierDetails,
          relatedSupplierInfo: action?.data //?.relatedSupplierInfo
        }
      }
    case GET_RELATED_SUPPLIER_WITH_ID_FAIL:
      return {
        ...state,
        // isLoadingChildSupplier: false,
        // isLoadingMasterDetail: false,
        isLoadingRelatedSupplier: false,
        relatedSupplierDetails: {
          ...state.relatedSupplierDetails,
          relatedSupplierInfo: []
        }
      }
    case ADD_SUPPLIER_HISTORY_START:
      return {
        ...state,
        isLoadingChildSupplier: true
      }
    case ADD_SUPPLIER_HISTORY_SUCCESS:
      return {
        ...state,
        isLoadingChildSupplier: false,
        masterSupplierDetails: {
          ...state.masterSupplierDetails,
          supplierHistory: action?.data?.data ? action?.data?.data : {},
        },
        relatedSupplierDetails: {
          ...state.relatedSupplierDetails,
          relatedSupplierInfo: {
            ...state.relatedSupplierDetails.relatedSupplierInfo,
            supplierHistory: action?.data?.data ? action?.data?.data : {}
          }
        }
      }
    case ADD_SUPPLIER_HISTORY_FAIL:
      return {
        ...state,
        isLoadingChildSupplier: false,
        supplierHistory: []
      }
    case GET_ALL_SUPPLIERS_DATA_START:
      return {
        ...state,
        allSuppliers: []
      }
    case GET_ALL_SUPPLIERS_DATA_SUCCESS:
      return {
        ...state,
        allSuppliers: action?.data
      }
    case GET_ALL_SUPPLIERS_DATA_FAIL:
      return {
        ...state,
        allSuppliers: []
      }
    case REMOVE_MASTER_SUPPLIER_DETAILS:
      return {
        ...state,
        masterSupplierDetails: {}
      }
    case GET_LOCATION_BASED_MASTER_SUPPLIERS_START:
      return {
        ...state,
        isLoadingLocationMasterSupplier: true
      }
    case GET_LOCATION_BASED_MASTER_SUPPLIERS_FAILED:
      return {
        ...state,
        isLoadingLocationMasterSupplier: false
      }
    case GET_LOCATION_BASED_MASTER_SUPPLIERS_SUCCESS:
      if (action.searchListLength === 0) {
        return {
          ...state,
          locationMasterSuppliers: action.data,
          isLoadingLocationMasterSupplier: false
        }
      } else {
        return {
          ...state,
          isLoadingLocationMasterSupplier: false
        }
      }
    case GET_ALL_MASTER_SUPPLIERS_DATA_START:
      return {
        ...state,
        allMasterSuppliers: []
      }
    case GET_ALL_MASTER_SUPPLIERS_DATA_SUCCESS:
      return {
        ...state,
        allMasterSuppliers: action?.data
      }
    case GET_ALL_MASTER_SUPPLIERS_DATA_FAIL:
      return {
        ...state,
        allMasterSuppliers: []
      }
    case GET_LOCATION_BASED_MASTER_SUPPLIERS_FOR_QA_START:
      return {
        ...state,
        isLoadingLocationMasterSupplier: true,
      }
    case GET_LOCATION_BASED_MASTER_SUPPLIERS_FOR_QA_SUCCESS:
      return {
        ...state,
        isLoadingLocationMasterSupplier: false,
        locationBasedMasterSuppliersForQA: action.data
      }
    case GET_LOCATION_BASED_MASTER_SUPPLIERS_FOR_QA_FAIL:
      return {
        ...state,
        isLoadingLocationMasterSupplier: false,
      }
    case CREATE_CHILD_START:
      return {
        ...state,
        isCreatingChild: true
      }
    case CREATE_CHILD_SUCCESS:
      return {
        ...state,
        isCreatingChild: false
      }
    case CREATE_CHILD_FAIL:
      return {
        ...state,
        isCreatingChild: false
      }
    case UPDATE_GLOBAL_ACCEPTANCE:
      if (action.supType === 'master') {
        return {
          ...state,
          masterSupplierDetails: {
            ...state.masterSupplierDetails,
            cardInfo: action.data?.cardData,
            detailInfo: action.data?.detailInfo
          }
        }
      } else {
        return {
          ...state,
          relatedSupplierDetails: {
            ...state.relatedSupplierDetails,
            relatedSupplierInfo: {
              ...state.relatedSupplierDetails.relatedSupplierInfo,
              masterSupplierInfo: {
                ...state.relatedSupplierDetails.relatedSupplierInfo.masterSupplierInfo,
                cardInfo: action.data?.cardData
              }
            }
          }
        }
      }
    case UPDATE_SUPPLIERS_SEARCH_LIST:
      return {
        ...state,
        suppliersSearchList: action.data ? action.data : {}
      }
    case UPDATE_SUPPLIERS_SEARCH_RESULTS:
      return {
        ...state,
        suppliersSearchResults: {
          ...state.suppliersSearchResults,
          masters: action.data?.hasOwnProperty('masters') ? action.data?.masters : (state.suppliersSearchResults?.masters || {}),
          childs: action.data?.hasOwnProperty('childs') ? action.data?.childs : (state.suppliersSearchResults?.childs || {}),
          locationMasters: action.data?.hasOwnProperty('locationMasters') ? action.data?.locationMasters : (state.suppliersSearchResults?.locationMasters || {})
        }
      }
    case GET_CONTACTS_WITH_SUPPLIER_IDS_START:
      return {
        ...state,
        isLoadingSupplierContacts: true
      }
    case GET_CONTACTS_WITH_SUPPLIER_IDS_SUCCESS:
      if (action.supType === 'master') {
        return {
          ...state,
          isLoadingSupplierContacts: false,
          masterSupplierDetails: {
            ...state.masterSupplierDetails,
            contacts: action?.data ? action?.data : []
          }
        }
      } else if (action.supType === 'relatedMaster') {
        return {
          ...state,
          isLoadingSupplierContacts: false,
          relatedSupplierDetails: {
            ...state.relatedSupplierDetails,
            relatedSupplierInfo: {
              ...state.relatedSupplierDetails.relatedSupplierInfo,
              masterSupplierInfo: {
                ...state.relatedSupplierDetails.relatedSupplierInfo.masterSupplierInfo,
                contacts: action?.data ? action?.data : []
              }
            }
          }
        }
      } else {
        return {
          ...state,
          isLoadingSupplierContacts: false,
          relatedSupplierDetails: {
            ...state.relatedSupplierDetails,
            relatedSupplierInfo: {
              ...state.relatedSupplierDetails.relatedSupplierInfo,
              contacts: action?.data ? action?.data : []
            }
          }
        }
      }
    case GET_CONTACTS_WITH_SUPPLIER_IDS_FAIL:
      if (action.supType === 'master') {
        return {
          ...state,
          isLoadingSupplierContacts: false,
          masterSupplierDetails: {
            ...state.masterSupplierDetails,
            contacts: []
          }
        }
      } else if (action.supType === 'relatedMaster') {
        return {
          ...state,
          isLoadingSupplierContacts: false,
          relatedSupplierDetails: {
            ...state.relatedSupplierDetails,
            relatedSupplierInfo: {
              ...state.relatedSupplierDetails.relatedSupplierInfo,
              masterSupplierInfo: {
                ...state.relatedSupplierDetails.relatedSupplierInfo.masterSupplierInfo,
                contacts: []
              }
            }
          }
        }
      } else {
        return {
          ...state,
          isLoadingSupplierContacts: false,
          relatedSupplierDetails: {
            ...state.relatedSupplierDetails,
            relatedSupplierInfo: {
              ...state.relatedSupplierDetails.relatedSupplierInfo,
              contacts: []
            }
          }
        }
      }
    default:
      return state
  }
}

export default vendor